import s from './explanation.module.scss';

import ogDay from '../img/screen-shots/og-day.png';

import spacial0 from '../img/screen-shots/spacial-0.png'
import spacial1 from '../img/screen-shots/spacial-1.png'

import combined0 from '../img/screen-shots/combined-0.png'
import combined1 from '../img/screen-shots/combined-1.png'
import combined2 from '../img/screen-shots/combined-2.png'

import achievement from '../img/screen-shots/achievement.png'


export default function explanation() {
    return (
        <>
            <div className={s.textContainer}>
                <BoldTItle
                    beforeAccent='It was 12th'
                    accent='May'
                    afterAccent='2022'
                />
                <RegularText animation='fade-right'
                    content='I was minding my business as usual and thinking about time how fast it is passing. It felt like, I spent the the whole life in a bubble.'
                />
                <RegularText animation='fade-left'
                    content='I can realize that it is not time which is passing fast, It is me how is not appreciating the present moment.'
                />
                <RegularText animation='fade-right'
                    content={`But I didn't wanted to let it happen any more. From then I started to think for a visual realizer which will remind me actively that "Hey wake up sun is already on his duty"`}
                />
                <RegularText animation='fade-left'
                    content={`So I started to think for some kind of way that will aware me that I have passed this amount of time.`}
                />
                <RegularText animation='fade-right'
                    content={`At first I thought to write down in tally form for every day and keep and index of it, But we all know, pen and paper kind of sucks :). At last I came across this enjoying (ig) idea.`}
                />
                <div data-aos='fade-up' className={s.formula}>
                    <p>
                        Post a post regularly, increasing the count by 1 relatively.
                    </p>
                </div>
            </div>
            <OgPost />
            <div className={s.textContainer}>
                <LightText animation='fade-down'
                    content='It is been a while now, I am posting and have to say it is going smooth. Although posting regularly is kind of a task for me. That is why sometimes I forget to post. You might think what kind of lazy I am who say this job a task. Yeah I forget sometimes to post a day. But it is what it is.'
                />
                <div className={s.indentedBold}>
                    <RegularText
                        content='As you know that most often I forget to post but I fulfill it by bundling with the next day, like this ... '
                    />
                </div>
            </div>

            <ImagesCom />
            <div className={s.textContainer}>
                <LightText content='
                    Again posting a day regularly feels kind of dull, that is way I started to make few changes to spice things up ...
                '/>
            </div>
            <ImagesSp />
            <div className={s.textContainer}>
                <LightText content='
                    I know this changes are not out of the world but it is better something then nothing :-:
                '/>
                <div className={s.indentedBold}>
                    <RegularText
                        content="Lets wrap this up, Where we are right now? Are the purpose of all this accomplished?"
                    />
                </div>
                <div className={s.boldTitleContainer}>
                    <h1 data-aos='zoom-in' className={s.ans}>The answer is, kind of ...</h1>
                </div>

                <RegularText
                    content="Although I don't have a lot of things to show but I am leaving something which feels to me a success"
                />
            </div>
            <div className={s.imgContainer}>
                <img data-aos='zoom-out-down' src={achievement} alt="" />
            </div>
            <div className={s.textContainer}>
                <BoldText
                    content='Here you can see flocks are expressing about the time flow and what they have achieved.'
                />
                <LightText className={s.center}
                    content='At the end closing it without stretching anymore.'
                />
                <BoldText animation='slide-right' className={s.small}
                    content='Signing of ...'
                />
            </div>

        </>
    )
}

export function BoldTItle(props) {
    return (
        <div data-aos='zoom-in' className={s.boldTitleContainer}>
            <h1>
                {props.beforeAccent} <span className='accent'>{props.accent}</span> {props.afterAccent}
            </h1>
        </div>
    )
}

export function RegularText(props) {
    return (
        <div data-aos-offset="20" data-aos-duration="450" data-aos={props.animation} className={`${s.regularTextContainer} ${props.className}`}>
            <p>
                {props.content}
            </p>
        </div>
    )
}

export function LightText(props) {
    return (
        <div data-aos={props.animation} className={`${s.lightTextContainer} ${props.className}`}>
            <p>
                {props.content}
            </p>
        </div>
    )
}

export function BoldText(props) {
    return (
        <div data-aos={props.animation} className={`${s.boldTextContainer} ${props.className}`}>
            <p>
                {props.content}
            </p>
        </div>
    )
}


export function OgPost() {
    return (
        <div className={s.ogPostContainer}>
            <BoldTItle
                beforeAccent='The original Day from 22th'
                accent='May'
                afterAccent='2022'
            />

            <div data-aos='slide-up' className={s.imgContainer}>
                <img src={ogDay} alt="" />
            </div>

            <RegularText
                content='From that you all are seeing a day posted by me telling it is a brand new day!!'
            />

        </div>
    )
}

export function ImagesCom() {
    return (
        <div className={`${s.imgContainer} ${s.imgContainerCom}`}>
            <img data-aos='fade-left' src={combined0} alt="" />
            <img data-aos='fade-right' src={combined1} alt="" />
            <img data-aos='fade-left' src={combined2} alt="" />
        </div>
    )
}

export function ImagesSp() {
    return (
        <div className={`${s.imgContainer} ${s.imgContainerSp}`}>
            <img data-aos='fade-right' src={spacial0} alt="" />
            <img data-aos='fade-left' src={spacial1} alt="" />
        </div>
    )
}
